import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {IConclusion, IPhase} from 'types/project';
import {ResponseData} from 'types/response-data';

const getProjectPhases = api.injectEndpoints({
  endpoints: builder => ({
    getProjectPhases: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `projects/${params.id}/phases`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<Array<IPhase>>;

export const {useGetProjectPhasesQuery} = getProjectPhases;
